import { Injectable } from '@angular/core';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Fires Meta Pixel events after index.html has initialized fbq.
 * No pixel ID here — init is done in index.html.
 */
@Injectable({
  providedIn: 'root',
})
export class MetaPixelService {
  /**
   * Standard event for completed sign-up. Meta attaches to the pixel from fbq('init', ...).
   */
  trackCompleteRegistration(flow: 'lander' | 'register' | 'signup'): void {
    if (typeof window === 'undefined') {
      return;
    }
    const fbq = window.fbq;
    if (typeof fbq !== 'function') {
      return;
    }
    const content_name =
      flow === 'lander' ? 'lander_signup' : flow === 'register' ? 'org_register' : 'signup_page';
    fbq('track', 'CompleteRegistration', { content_name });
  }
}
